import { z } from 'zod'
import type { Segment } from '../previsions/-search-schema'

export const CATEGORY_KINDS = [
  'commercial',
  'industriel',
  'reappro',
] as const satisfies readonly Segment[]

export type CategoryKind = (typeof CATEGORY_KINDS)[number]

export const categorySearchSchema = z.object({
  tab: z.enum(['forecast', 'backtest']).default('forecast'),
  kind: z.enum(CATEGORY_KINDS).default('commercial'),
  storeIds: z.array(z.number()).default([]),
  categoryIds: z.array(z.number()).default([]),
  days: z.number().min(1).max(31).default(31),
  corrections: z.boolean().default(false),
  vmjDays: z.number().default(10),
  weekdaysOnly: z.boolean().default(true),
  anchor: z.string().optional(),
})

export type CategorySearch = z.infer<typeof categorySearchSchema>
